import { GameEngine } from "neo-games";
import { GameManager } from "../Game/Managers/GameManager";

const key_GameEnableReelsStop = "GameEnableReelsStop";
const key_GameEnableQuickSpin = "GameEnableQuickSpin";
const key_QuickSpinDialogCount = "QuickSpinDialogCount";
const key_QuickSpinDecayDelay = "QuickSpinDecayDelay";
const key_MinGameRoundDuration = "MinGameRoundDuration";
const key_GameRoundMinSpan = "GameRoundMinSpan";
const key_FRBGameRoundMinSpan = "FRBGameRoundMinSpan";
const key_UIShowTime = "UIShowTime";
const key_GUIShowSessionTime = "GUI_ShowSessionTime";
const key_GUIShowSessionTimeStartValue = "GUI_ShowSessionTimeStartValue";
const key_UseServerTime = "UseServerTime";
const key_UseHtmlAudio = "UseHtmlAudio";
const key_FullscreenOnClick = "FullscreenOnClick";
const key_UseCoins = "UseCoins";
const key_AutoplayGambleEnabled = "AutoplayGambleEnabled";
const key_AutoplayMode = "AutoplayMode";
const key_AutoplayCounts = "AutoplayCounts";
const key_AutoplayLossLimit = "AutoplayLossLimit";
const key_AutoplaySingleWinLimit = "AutoplaySingleWinLimit";
const key_HelpShowGameLimit = "HelpShowGameLimit";
const key_HelpShowRTP = "HelpShowRTP";
const key_ShowGameRoundsHistory = "ShowGameRoundsHistory";
const key_ExpirationResolveHours = "ExpirationResolveHours";
const key_AutoplayModeSpeed = "AutoplayModeSpeed";
const key_HideAmountsEnabled = "HideAmountsEnabled";
const key_AutoplayModeEnabled = "AutoplayModeEnabled";
const key_ResetCoinCountOnDenomChange = "ResetCoinCountOnDenomChange";
const key_CollectOnUnCalculatedWin = "CollectOnUnCalculatedWin";
const key_PluginUrl = "PluginUrl";
const key_PluginOrigin = "PluginOrigin";
const key_Platform = "Platform";
const key_PollCredit = "PollCredit";
const key_ShowDecimalPlaces = "ShowDecimalPlaces";
const key_SelectorRolloutDuration = "SelectorRolloutDuration";
const key_DisplayCurrencies = "DisplayCurrencies";
const key_CanvasFallback = "CanvasFallback";
const key_GameRoundIdVisible = "GameRoundIdVisible";
const key_MuteOnLostFocus = "MuteOnLostFocus";
const key_ShowCashierMessage = "ShowCashierMessage";
const key_CashierMessageShowRefreshBalanceButton = "CashierMessageShowRefreshBalanceButton";
const key_CashierUrl = "CashierUrl";
const key_DisableUntrustedClicks = "DisableUntrustedClicks";
const key_PlayerSessionReconnectionInterval = "PlayerSessionReconnectionInterval";
const key_ApplicationGatewayUrl = "ApplicationGatewayUrl";
const key_EventTrackerEnabled = "EventTrackerEnabled";
const key_GameEnableVibration = "GameEnableVibration";
const key_PaytableUseValue = "PaytableUseValue";
const key_AllowPlayFromRules = "AllowPlayFromRules";

const key_GUI_HistoryUrl = "GUI_HistoryUrl";
const key_RCI_HistoryUrl = "RCI_HistoryUrl";
const key_RCI_Info = "RCI_Info";
const key_RCI_IntervalInfo = "RCI_IntervalInfo";
const key_RCI_ShowHistoryButton = "RCI_ShowHistoryButton";

const key_FeatureAutoPlay = "FeatureAutoPlay";
const key_FeatureAutoPick = "FeatureAutoPick";

const key_ShowSimilarGames = "ShowSimilarGames";
const key_SimilarGamesList = "SimilarGamesList";
const key_ShowExitGameButton = "ShowExitGameButton";
const key_StaticContentUrl = "StaticContentUrl";
const key_ShowHomeButton = "ShowHomeButton";
const key_UsePortraitMode = "UsePortraitMode";
const key_FRBShowDenyButton = "FRBShowDenyButton";
const key_FRBShowPostponeButton = "FRBShowPostponeButton";
const key_StatusBar = "StatusBar";
const key_StatusBarData = "StatusBarData";

const key_ProgressiveBonusId = "ProgressiveBonusId";
const key_ProgressiveBonusContributeOnlyQualified = "ProgressiveBonusContributeOnlyQualified";
const key_ProgressiveBonusMinQualifyingBet = "ProgressiveBonusMinQualifyingBet";
const key_ProgressiveBonusMaxQualifyingBet = "ProgressiveBonusMaxQualifyingBet";
const key_ProgressiveBonusVisibleMax = "ProgressiveBonusVisibleMax";
const key_ProgressiveBonusHelpShowMaxVisibleLimit = "ProgressiveBonusHelpShowMaxVisibleLimit";
const key_ProgressiveBonusHelpShowCumulativeWinLimit = "ProgressiveBonusHelpShowCumulativeWinLimit";
const key_ProgressiveBonusTicketConstraint = "ProgressiveBonusTicketConstraint";
const key_UseJackpotLocalization = "UseJackpotLocalization";
const key_ProgressiveBonusTheme = "ProgressiveBonusTheme";

const key_SessionBalance = "SessionBalance";
const key_TotalBet = "TotalBet";
const key_TotalWin = "TotalWin";
const key_PlayerTokenId = "PlayerTokenId";
const key_ClientToken = "ClientToken";
const key_MaxBetEnabled = "MaxBetEnabled";
const key_ShowMaxBetMessage = "ShowMaxBetMessage";
const key_HelpShowGameModuleVersion = "HelpShowGameModuleVersion";
const key_NotifyBetHigherThanMin = "NotifyBetHigherThanMin";
const key_ShowPaytableAtStart = "ShowPaytableAtStart";
const key_HelpShowMaxPayoutProbability = "HelpShowMaxPayoutProbability";
const key_HelpShowMaxPayoutProbabilityFrequency = "HelpShowMaxPayoutProbabilityFrequency";

export class GameConfiguration extends GameEngine.GameConfigurationBase {
    /**
     * @property GameEnableReelsStop - game enable reels stop.
     */
    public get GameEnableReelsStop(): boolean {
        return this.getValue(key_GameEnableReelsStop, true);
    }

    /**
     * @property GameEnableQuickSpin - game allows automatic quick stop.
     */
    public get GameEnableQuickSpin(): boolean {
        return this.getValue(key_GameEnableQuickSpin, false);
    }

    /**
     * @property QuickSpinDialogCount - number of subsequent quick stops before dialog is shown.
     */
    public get QuickSpinDialogCount(): number {
        return this.getValue(key_QuickSpinDialogCount, 3);
    }

    public get QuickSpinDecayDelay(): number {
        return this.getValue(key_QuickSpinDecayDelay, 30);
    }

    /**
     * @property MinGameRoundDuration - number min round duration from start to stop reels
     */
    public get MinGameRoundDuration(): number {
        return this.getValue(key_MinGameRoundDuration, 0);
    }

    /**
     * @property GameRoundMinSpan - min game round duration in milliseconds
     */
    public get GameRoundMinSpan(): number {
        return this.getValue(key_GameRoundMinSpan, 0);
    }

    /**
     * @property FRBGameRoundMinSpan - min game round duration in frb in milliseconds
     */
    public get FRBGameRoundMinSpan(): number {
        return this.getValue(key_FRBGameRoundMinSpan, 0);
    }

    /**
     * @property UIShowTime
     */
    public get UIShowTime(): boolean {
        return this.getValue(key_UIShowTime, false);
    }

    /**
     * @property GUIShowSessionTime
     */
    public get GUIShowSessionTime(): boolean {
        return this.getValue(key_GUIShowSessionTime, false);
    }

    /**
     * @property GUIShowSessionTimeStartValue
     */
    public get GUIShowSessionTimeStartValue(): number {
        return this.getValue(key_GUIShowSessionTimeStartValue, 0);
    }

    /**
     * @property UseServerTime
     */
    public get UseServerTime(): boolean {
        return this.getValue(key_UseServerTime, false);
    }

    /**
     * @property UseHtmlAudio
     */
    public get UseHtmlAudio(): boolean {
        return this.getValue(key_UseHtmlAudio, false);
    }

    /**
     * @property FullscreenOnClick
     */
    public get FullscreenOnClick(): boolean {
        return this.getValue(key_FullscreenOnClick, false);
    }

    /**
     * @property UseCoins
     */
    public get UseCoins(): boolean {
        return this.getValue(key_UseCoins, false);
    }

    /**
     * @property AutoplayGambleEnabled - Enables/disables gamble feature during Autoplay
     */
    public get AutoplayGambleEnabled(): boolean {
        return this.getValue(key_AutoplayGambleEnabled, true);
    }

    /**
     * @property MaxBetEnabled Enables max bet button in game UI
     */
    public get MaxBetEnabled(): boolean {
        return this.getValue(key_MaxBetEnabled, false);
    }

    /**
     * @property ShowMaxBetMessage Enables max bet button confirmation dialog in game UI
     */
    public get ShowMaxBetMessage(): boolean {
        return this.getValue(key_ShowMaxBetMessage, false);
    }

    /**
     * @property AutoplayMode - Determines what autoplay features are available to the player:
     * Basic = Basic autoplay is used
     * Simple = simple autoplay is used
     * Advanced = advanced autoplay is used
     */
    public get AutoplayMode(): string {
        return this.getValue(key_AutoplayMode, "simple");
    }

    /**
     * @property AutoplayCounts - shows selection of preset Autoplay games for simple and advanced autoplay; -1 = no limit/infinite option
     */
    public get AutoplayCounts(): Array<number> {
        return this.getValue(key_AutoplayCounts, [-1, 1000, 750, 500, 250, 100, 75, 50, 25, 10]);
    }

    /**
     * @property AutoplayLossLimit - List of values shown to player, where player can set his Loss limit, available only in advanced autoplay; -1 = no limit option
     */
    public get AutoplayLossLimit(): Array<number> {
        return this.getValue(key_AutoplayLossLimit, [-1, 5, 20, 50]);
    }

    /**
     * @property AutoplaySingleWinLimit - List of values shown to player, where player can set his singleWinLimit; -1 = no limit option
     */
    public get AutoplaySingleWinLimit(): Array<number> {
        return this.getValue(key_AutoplaySingleWinLimit, [-1, 10, 20, 75]);
    }

    /**
     * @property HelpShowGameLimit - Show game limit in help.
     */
    public get HelpShowGameLimit(): boolean {
        return this.getValue(key_HelpShowGameLimit, true);
    }

    /**
     * @property HelpShowRTP - Show rtp in help.
     */
    public get HelpShowRTP(): boolean {
        return this.getValue(key_HelpShowRTP, true);
    }

    /**
     * @property ShowGameRoundsHistory - show button which open new window to last 10 game rounds.
     */
    public get ShowGameRoundsHistory(): boolean {
        return GameManager.gameResponse.roundId > -1 && this.getValue(key_ShowGameRoundsHistory, true);
    }

    /**
     * @property ExpirationResolveHours - Automatic game resolve
     */
    public get ExpirationResolveHours(): number {
        return this.getValue(key_ExpirationResolveHours, -1);
    }

    /**
     * @property AutoplayModeSpeed - can speed up reel rotation in autoplay - !!!! for now only in Firebird
     * standard = normal autoplay flow
     * fast = if game has stop button enabled reel rotation will stop rotation after response will came from server
     */
    public get AutoplayModeSpeed(): string {
        return this.getValue(key_AutoplayModeSpeed, "standard");
    }

    /**
     * @property HideAmountsEnabled - show hide buttons for credit and bet - !!!! for now only in Firebird
     */
    public get HideAmountsEnabled(): boolean {
        return this.getValue(key_HideAmountsEnabled, false);
    }

    /**
     * @property AutoplayModeEnabled - enable or disable autoplay functionality - !!!! for now only in Firebird
     */
    public get AutoplayModeEnabled(): boolean {
        return this.getValue(key_AutoplayModeEnabled, true);
    }

    /**
     * @property ResetCoinCountOnDenomChange
     * true => reset coin count to lowest value available after every denomination change
     * false => coin count is not changed if in the new denomination is available, if its not available -> same or closest lower coin count is set
     */
    public get ResetCoinCountOnDenomChange(): boolean {
        return this.getValue(key_ResetCoinCountOnDenomChange, true);
    }

    /**
     * @property CollectOnUnCalculatedWin
     * true => collect win on spin when player didnt see calculated win in win box
     * false => standard flow
     */
    public get CollectOnUnCalculatedWin(): boolean {
        return this.getValue(key_CollectOnUnCalculatedWin, false);
    }

    /**
     * @property PluginUrl - if is not empty create hidden iframe for communication with platforms and showing reality check (for now only for CZ fortuna - iforium)
     */
    public get PluginUrl(): string {
        return this.getValue(key_PluginUrl, "");
    }

    /**
     * @property PluginUrl - if is not empty  and plugin URL creates hidden iframe this parameter will be applied for messaging between iframe and game
     */
    public get PluginOrigin(): string {
        return this.getValue(key_PluginOrigin, "");
    }

    /**
     * @property Platform - name of platform for external apis - for now we supported only iforium platform
     */
    public get Platform(): string {
        return this.getValue(key_Platform, "");
    }

    /**
     * @property PollCredit
     * -1 => Not used
     * > 0 => Number in miliseconds run timer to refresh balance when credit is lower than bet in closed gameround
     */
    public get PollCredit(): number {
        return this.getValue(key_PollCredit, -1);
    }

    /**
     * @property ShowDecimalPlaces - all wins and currency values are shown with selected decimal places (except RTP of course)
     */
    public get ShowDecimalPlaces(): number {
        return this.getValue(key_ShowDecimalPlaces, 2);
    }

    /**
     * @property SelectorRolloutDuration
     * 0 => Disabled
     * > 0 => Selector rollout duration in seconds.
     */
    public get SelectorRolloutDuration(): number {
        return this.getValue(key_SelectorRolloutDuration, 5);
    }

    /**
     * @property DisplayCurrencies
     * @returns {string[]}
     */
    public get DisplayCurrencies(): string[] {
        return this.getValue(key_DisplayCurrencies, []);
    }

    /**
     * @property CanvasFallback
     * @returns {boolean}
     */
    public get CanvasFallback(): boolean {
        return this.getValue(key_CanvasFallback, false);
    }

    /**
     * @property GameRoundIdVisible
     * @returns {boolean}
     */
    public get GameRoundIdVisible(): boolean {
        return this.getValue(key_GameRoundIdVisible, true);
    }

    /**
     * @property MuteOnLostFocus
     * @returns {boolean}
     */
    public get MuteOnLostFocus(): boolean {
        return this.getValue(key_MuteOnLostFocus, true);
    }

    /**
     * @property ShowCashierMessage
     * @returns {boolean}
     */
    public get ShowCashierMessage(): boolean {
        return this.getValue(key_ShowCashierMessage, false);
    }

    /**
     * @property CashierMessageShowRefreshBalanceButton
     * @returns {boolean}
     */
    public get CashierMessageShowRefreshBalanceButton(): boolean {
        return this.getValue(key_CashierMessageShowRefreshBalanceButton, false);
    }

    /**
     * @property CashierUrl
     * @returns {string}
     */
    public get CashierUrl(): string {
        return this.getValue(key_CashierUrl, "");
    }

    /**
     * @property DisableUntrustedClicks
     * @returns {string}
     */
    public get DisableUntrustedClicks(): boolean {
        return this.getValue(key_DisableUntrustedClicks, true);
    }

    /**
     * @property GUIHistoryUrl
     * @returns {string}
     */
    public get GUIHistoryUrl(): string {
        return this.getValue(key_GUI_HistoryUrl, "");
    }

    /**
     * @property RCIHistoryUrl
     * @returns {string}
     */
    public get RCIHistoryUrl(): string {
        return this.getValue(key_RCI_HistoryUrl, "");
    }

    /**
     * @property RCIInfo
     * @returns {boolean}
     */
    public get RCIInfo(): boolean {
        return this.getValue(key_RCI_Info, false);
    }

    /**
     * @property RCIIntervalInfo
     * @returns {boolean}
     */
    public get RCIIntervalInfo(): boolean {
        return this.getValue(key_RCI_IntervalInfo, true);
    }

    /**
     * @property RCIShowHistoryButton
     * @returns {boolean}
     */
    public get RCIShowHistoryButton(): boolean {
        return this.getValue(key_RCI_ShowHistoryButton, false);
    }

    /**
     *
     * @returns {number}
     * @constructor
     */
    public get FeatureAutoPlay(): number {
        return (this.getValue(key_FeatureAutoPlay, 0) / 1000) * 60;
    }

    /**
     *
     * @returns {boolean}
     * @constructor
     */
    public get FeatureAutoPick(): boolean {
        return this.getValue(key_FeatureAutoPick, false);
    }

    /**
     * @property ShowSimilarGames
     * @returns {boolean}
     */
    public get ShowSimilarGames(): boolean {
        return this.getValue(key_ShowSimilarGames, false);
    }

    /**
     * @property SimilarGamesList
     * @returns {array string}
     */
    public get SimilarGamesList(): Array<string> {
        return this.getValue(key_SimilarGamesList, []);
    }

    /**
     * @property ShowExitGameButton
     * @returns {boolean}
     */
    public get ShowExitGameButton(): boolean {
        return this.getValue(key_ShowExitGameButton, true);
    }

    /**
     * @property StaticContentUrl
     * @returns {string}
     */
    public get StaticContentUrl(): string {
        return this.getValue(key_StaticContentUrl, "");
    }

    /**
     * @property ShowHomeButton
     * @returns {boolean}
     */
    public get ShowHomeButton(): boolean {
        return this.getValue(key_ShowHomeButton, true);
    }

    /**
     * @property UsePortraitMode
     * @returns {boolean}
     */
    public get UsePortraitMode(): boolean {
        return this.getValue(key_UsePortraitMode, true);
    }

    /**
     * @property FRBShowDenyButton
     * @returns {boolean}
     */
    public get FRBShowDenyButton(): boolean {
        return this.getValue(key_FRBShowDenyButton, true);
    }

    /**
     * @property FRBShowPostponeButton
     * @returns {boolean}
     */
    public get FRBShowPostponeButton(): boolean {
        return this.getValue(key_FRBShowPostponeButton, true);
    }

    /**
     * @property StatusBar
     * @returns {array string}
     */
    public get StatusBar(): Array<string> {
        return this.getValue(key_StatusBar, []);
    }

    /**
     * @property StatusBarData
     * @returns {object}
     */
    public get StatusBarData(): Object {
        return this.getValue(key_StatusBarData, {});
    }

    /**
     * @property ProgressiveBonusId
     * @returns {number}
     */
    public get ProgressiveBonusId(): number {
        return this.getValue(key_ProgressiveBonusId, -1);
    }

    /**
     * @property ProgressiveBonusContributeOnlyQualified
     * @returns {boolean}
     */
    public get ProgressiveBonusContributeOnlyQualified(): boolean {
        return this.getValue(key_ProgressiveBonusContributeOnlyQualified, false);
    }

    /**
     * @property ProgressiveBonusMinQualifyingBet
     * @returns {number}
     */
    public get ProgressiveBonusMinQualifyingBet(): number {
        return this.getValue(key_ProgressiveBonusMinQualifyingBet, -1);
    }

    /**
     * @property ProgressiveBonusMaxQualifyingBet
     * @returns {number}
     */
    public get ProgressiveBonusMaxQualifyingBet(): number {
        return this.getValue(key_ProgressiveBonusMaxQualifyingBet, -1);
    }

    /**
     * @property ProgressiveBonusVisibleMax
     * @returns {number}
     */
    public get ProgressiveBonusVisibleMax(): number {
        return this.getValue(key_ProgressiveBonusVisibleMax, -1);
    }

    /**
     * @property ProgressiveBonusHelpShowMaxVisibleLimit
     * @returns {boolean}
     */
    public get ProgressiveBonusHelpShowMaxVisibleLimit(): boolean {
        return this.getValue(key_ProgressiveBonusHelpShowMaxVisibleLimit, true);
    }

    /**
     * @property ProgressiveBonusHelpShowCumulativeWinLimit
     * @returns {boolean}
     */
    public get ProgressiveBonusHelpShowCumulativeWinLimit(): boolean {
        return this.getValue(key_ProgressiveBonusHelpShowCumulativeWinLimit, true);
    }

    /**
     * @property ProgressiveBonusTicketConstraint
     * @returns {string}
     */
    public get ProgressiveBonusTicketConstraint(): string {
        return this.getValue(key_ProgressiveBonusTicketConstraint, "");
    }

    /**
     * @property UseJackpotLocalization
     * @returns {boolean}
     */
    public get UseJackpotLocalization(): boolean {
        return this.getValue(key_UseJackpotLocalization, false);
    }

    /**
     * @property ProgressiveBonusTheme
     * @returns {string}
     */
    public get ProgressiveBonusTheme(): string {
        return this.getValue(key_ProgressiveBonusTheme, "");
    }

    /**
     * @property SessionBalance
     * @constructor
     */
    public get SessionBalance(): number {
        return this.getValue(key_SessionBalance, 0);
    }

    /**
     * @propertyTotalBet
     * @constructor
     */
    public get TotalBet(): number {
        return this.getValue(key_TotalBet, 0);
    }

    /**
     * @propertyTotalWin
     * @constructor
     */
    public get TotalWin(): number {
        return this.getValue(key_TotalWin, 0);
    }

    /**
     * @propertyPlayerTokenId
     * @constructor
     */
    public get PlayerTokenId(): string {
        return this.getValue(key_PlayerTokenId, "");
    }

    /**
     * @propertyPlayerSessionReconnectionInterval
     * @constructor
     */
    public get PlayerSessionReconnectionInterval(): number {
        return this.getValue(key_PlayerSessionReconnectionInterval, 0);
    }

    /**
     * @property ApplicationGatewayUrl
     * @constructor
     */
    public get ApplicationGatewayUrl(): string {
        return this.getValue(key_ApplicationGatewayUrl, "");
    }

    /**
     * @property GameEnableVibration
     * @constructor
     */
    public get GameEnableVibration(): boolean {
        return this.getValue(key_GameEnableVibration, false);
    }

    /**
     * @property HelpShowGameModuleVersion
     * true - Enable game module version info in Help.
     * false - Disable game module version info in Help.
     */
    public get HelpShowGameModuleVersion(): boolean {
        return this.getValue(key_HelpShowGameModuleVersion, false);
    }

    /**
     * @property NotifyBetHigherThanMin
     * true - Set bet to minimal on game start and show
     *        notification after if game entered during
     *        feature using bet other than min bet.
     * false - Disable notification and bet update
     */
    public get NotifyBetHigherThanMin(): boolean {
        return this.getValue(key_NotifyBetHigherThanMin, false);
    }

    /**
     * @property HelpShowMaxPayoutProbability
     * true - Show additional info about Max Payout
     *        Probability in Help.
     */
    public get HelpShowMaxPayoutProbability(): boolean {
        return this.getValue(key_HelpShowMaxPayoutProbability, false);
    }

    /**
     * @property HelpShowMaxPayoutProbabilityFrequency
     * true - Show additional info about Max Payout
     *        Probability Frequency in Help.
     */
    public get HelpShowMaxPayoutProbabilityFrequency(): boolean {
        return this.getValue(key_HelpShowMaxPayoutProbabilityFrequency, false);
    }

    /**
     * @property ShowPaytableAtStart
     * If true, the game must show the paytable at start of the game session
     */
    public get ShowPaytableAtStart(): boolean {
        return this.getValue(key_ShowPaytableAtStart, false);
    }

    /**
     * @property PaytableUseValue
     * @constructor
     */
    public get PaytableUseValue(): boolean {
        return this.getValue(key_PaytableUseValue, false);
    }

    /**
     * @property AllowPlayFromRules
     * @constructor
     */
    public get AllowPlayFromRules(): boolean {
        return this.getValue(key_AllowPlayFromRules, true);
    }

    /**
     * @propertyUseWebSocket
     * @constructor
     */
    public get EventTrackerEnabled(): boolean {
        return this.getValue(key_EventTrackerEnabled, false);
    }

    /**
     * @propertyClientToken
     * @constructor
     */
    public get ClientToken(): string {
        return this.getValue(key_ClientToken, "");
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Common/GameConfiguration.ts
 **/